import { motion } from "framer-motion";
import { MaskLines } from "./Reveal";

const line = "The universe still has many secrets left to reveal!";

export const SignOff = () => (
  <section data-testid="signoff-callout" className="relative px-5 sm:px-10 lg:px-16 py-24 sm:py-36 overflow-hidden">
    <div className="absolute inset-0 grid-lines opacity-30" />
    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[70vw] h-[70vw] max-w-[900px] max-h-[900px] rounded-full bg-lime/10 blur-[120px]" />
    <h2 className="relative font-hand text-6xl sm:text-8xl lg:text-[9rem] leading-[0.95] text-white">
      <MaskLines lines={["So stay curious!", <span className="text-lime pl-[8vw]">Ask questions!</span>, <span className="pl-[16vw]">Follow the evidence!</span>]} />
    </h2>
    <motion.p
      data-testid="universe-secrets-text"
      className="relative mt-16 font-mono font-bold text-base sm:text-xl text-zinc-200 flex flex-wrap"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.1 }}
      variants={{ show: { transition: { staggerChildren: 0.03, delayChildren: 0.6 } } }}
    >
      <span className="text-lime mr-3">&gt;</span>
      {line.split(" ").map((word, w) => (
        <span key={w} className="whitespace-nowrap mr-[0.6em]">
          {word.split("").map((ch, i) => (
            <motion.span key={i} variants={{ hidden: { opacity: 0.15 }, show: { opacity: 1 } }}>{ch}</motion.span>
          ))}
        </span>
      ))}
      <span className="ml-1 w-3 h-6 bg-lime animate-blink" />
    </motion.p>
  </section>
);
